import { useQuery } from 'react-query';
import { QUERY_STALE_TIME } from 'config';
import PhoneApi from './api';

export function useGetPhoneCompanies() {
  return useQuery('phone_companies', PhoneApi.getCompanies, {
    staleTime: QUERY_STALE_TIME,
  });
}

export function useGetCompanyFromNumber(phoneLine: string) {
  const shouldFetch = phoneLine?.length === 10;
  return useQuery(
    [`phones`, phoneLine],
    (key, phone_line: string) =>
      PhoneApi.getCompanyFromNumber({ params: { phone_line } }),
    { enabled: shouldFetch }
  );
}

export function useGetBillingPhone(phoneNumber?: string) {
  return useQuery(
    [`billing_phone`, phoneNumber],
    () => PhoneApi.validateBillingPhone({ params: { phoneNumber } }),
    {
      enabled: false,
      cacheTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
}
